import Image from "next/image";
import styles from "./AboutTeam.module.css";
import { Description } from "@/utils/utils";

interface Tile {
  id: number;
  title_description: {
    id: number;
    title: string;
    description: string;
  };
  images: {
    id: number;
    documentId: string;
    url: string;
    alternativeText: string;
  }[];
}
interface Props {
  data: Tile[];
}

const AboutTeam: React.FC<Props> = ({ data }) => {
  return (
    <div className="container">
      <div className={styles.innerContainer}>
        <div className={styles.left}>
          <Image
            src={data[0]?.images[0]?.url}
            alt={data[0]?.images[0]?.alternativeText}
            title={data[0]?.images[0]?.alternativeText}
            className={`${styles.image} img-responsive`}
            width={580}
            height={346}
          />
        </div>
        <div className={styles.right}>
          <h4>{data[0]?.title_description?.title}</h4>
          <div className={styles.descriptioinBox}>
            <p>
              <Description
                text={data[0]?.title_description?.description}
                style={styles.rightDescription}
              />
            </p>
          </div>
        </div>
      </div>
      <div className={styles.innerContainer}>
        <div className={styles.left}>
          <h4>{data[1]?.title_description?.title}</h4>
          <p>
            <Description
              text={data[1]?.title_description?.description}
              style={styles.leftDescription}
            />
          </p>
        </div>
        <div className={styles.right}>
          <Image
            src={data[1]?.images[0]?.url}
            alt={data[1]?.images[0]?.alternativeText}
            title={data[1]?.images[0]?.alternativeText}
            className={`${styles.image} img-responsive`}
            width={580}
            height={388}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutTeam;
